import script from "./HeroView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroView.vue?vue&type=script&setup=true&lang=js"

import "./HeroView.vue?vue&type=style&index=0&id=73f9f200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f9f200"]])

export default __exports__